var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlutter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7739 0.164904C16.1779 1.36419 16.6227 8.85243 17.6486 11.5409C18.4958 13.7611 19.5312 15.783 21.0746 17.5379C22.2761 18.9039 23.881 20.0019 25.126 19.9247C26.3709 19.8475 27.3693 18.5274 27.5682 17.3787C27.7692 16.2184 27.7259 14.6904 26.0573 13.6575C24.3887 12.6246 24.8279 11.8668 25.4439 10.9763C26.06 10.0858 27.0869 8.60157 27.7533 6.53118C28.7414 3.46135 26.7641 -0.904579 21.7739 0.164904Z",
    fill: "#48C0B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08546 1.86598C12.5953 2.13829 15.5657 6.67818 16.476 9.42204C18.7107 13.9766 15.8867 21.7151 14.9232 23.7229C14.1603 25.3128 12.295 29.1213 8.69569 27.6806C5.67225 26.4703 5.68668 21.9418 6.30274 21.0513C7.12416 19.864 8.44786 18.9538 7.99606 17.4966C7.65742 16.4045 3.55602 14.6875 2.60163 13.9756C1.64724 13.2637 -0.14786 11.1834 0.00973068 8.49504C0.102449 6.91335 2.44814 1.5256 8.08546 1.86598Z",
    fill: "#48C0B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/flutter.3dfea1ac05f029708295ecfa3c279e9e.svg";
export { ForwardRef as ReactComponent };